import React, { useEffect, useLayoutEffect, useState } from "react";
import "../../../style/main.scss";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Icon } from "@iconify/react";
import { HashLoader } from "react-spinners";

const Agent = () => {
  const [agentModal, setAgentModal] = useState(false);
  const [createAgent, setCreateAgent] = useState(false);
  const [scriptModal, setScriptModal] = useState(false);
  const [generateModal, setGenerateModal] = useState(false);
  const [customerModal, setCustomerModal] = useState(false);
  const [enteredName, setEnteredName] = useState("");
  const [user, setUser] = useState(null);
  const [nameError, setNameError] = useState("");
  const [error, setError] = useState(null);
  const [promptType, setPromptType] = useState();
  const [agentPromptType, setAgentPromptType] = useState("");
  const [agentName, setAgentName] = useState();
  const [userId, setUserId] = useState();
  const navigate = useNavigate();
  const [agent, setAgent] = useState("");
  const [currentlyCreatedAgent, setCurrentlyCreatedAgent] = useState("");
  const [loadingForLoader, setLoadingForLoader] = useState(false);

  ////////////////////// PGINATION //////////////////////////
  const [currentPage, setCurrentPage] = useState(1);
  const agentsPerPage = 5;

  const totalPages = Math.ceil(agent.length / agentsPerPage);

  const indexOfLastAgent = currentPage * agentsPerPage;
  const indexOfFirstAgent = indexOfLastAgent - agentsPerPage;
  const currentAgents = agent.slice(indexOfFirstAgent, indexOfLastAgent);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  //////////////////////////////////////////////////////////

  var authToken = localStorage.getItem("bearerToken");
  const handleInputChange = (e) => {
    setEnteredName(e.target.value);
    setError(null);
    setAgentName(e.target.value);
    // console.log(e.target.value, "agent");
  };

  const handleSubmit = () => {
    console.log(enteredName, "enteredName.length");

    if (enteredName) {
      console.log("Entere");
      setUser(enteredName);
      setEnteredName("");
      setError(null);
      handleCreateAgentModal();
    } else {
      console.log("else Entere");
      setNameError("Please enter a name");
    }
  };

  const handleAgentModal = () => {
    setAgentModal(!agentModal);
  };
  const handleCreateAgentModal = () => {
    setAgentModal(false);
    setCreateAgent(!createAgent);
  };

  const handleScriptModal = () => {
    //model2
    setCreateAgent(false);
    setScriptModal(!scriptModal);
  };

  const handleGenerateModal = () => {
    setScriptModal(false);
    setGenerateModal(!generateModal);
  };
  const handleCustomerModal = () => {
    setAgentModal(false);
    setCustomerModal(!customerModal);
  };

  const handlePromptType = (value) => {
    console.log(value);
    setAgentPromptType(value);
    setPromptType(value);
  };
  const handlesetAgentName = async (value) => {
    await handleAgentRequest(value);
  };
  const handleTextRequest = async (tempAgentId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/text`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          promptType: promptType,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log("agent Data", data);
          navigate("/script", {
            state: {
              scriptResponse: data.prompt,
              textId: data._id,
              agentId: tempAgentId,
            },
          });
        })
        .catch((error) => console.error(error));
    } catch (error) {
      console.error("Error:", error.message);
    }
  };
  const handleAgentRequest = async (agentPromptType) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/agentCustom`,
        {
          // promptType: promptType,
          promptType: agentPromptType,
          agentName,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.data?.userExpired == true) {
        localStorage.clear();
        navigate("/login");
      }
      console.log(response.data, "data======");
      setUserId(response.data._id);
    } catch (error) {
      console.error("Error:", error.message);
    }
  };
  useLayoutEffect(() => {
    getAgentById();
  }, []);
  const getAgentById = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/getAllAgents`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      if (data.userExpired == true) {
        localStorage.clear();
        navigate("/login");
      } else {
        console.log(data);
        setAgent(data);
      }
    } catch (error) {
      console.error("Error fetching agent:", error);
    }
  };
  const handleDeleteAgent = async (agentId) => {
    setLoadingForLoader(true);

    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/agent/${agentId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        getAgentById();
        setLoadingForLoader(false);
      })
      .catch((error) => {
        setLoadingForLoader(false);
        console.log(error);
      });
  };
  return (
    <div>
      <div className="knowledge">
        <h1>Create Your First Agent</h1>
        <h4 className="mt-5 fs-4">
          To get started, create your first AI agent by clicking the button
          below. Once you create your agent, you can place it on live calls in
          minutes.
        </h4>
        <div className="agent-btn mt-5 mb-3">
          <button onClick={handleAgentModal}>Create AI Agent</button>
        </div>
      </div>

      <table className="table">
        <thead>
          <tr className="table-headers">
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Type</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody className="agent-table-body">
          {currentAgents.length > 0 ? (
            currentAgents.map((agentItem, index) => (
              <tr key={index}>
                <th
                  onClick={(e) => {
                    handleTextRequest(agentItem._id);
                  }}
                  scope="row"
                  style={{ cursor: "pointer" }}
                >
                  {index + 1}
                </th>
                <td
                  onClick={(e) => {
                    handleTextRequest(agentItem._id);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {agentItem.agentName}
                </td>
                <td
                  onClick={(e) => {
                    handleTextRequest(agentItem._id);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {agentItem.promptType}
                </td>
                <td>
                  <div className="Iconss">
                    <Icon
                      icon="fluent:delete-24-regular"
                      color="#dc2626"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleDeleteAgent(agentItem._id)}
                    />
                    {/* <Icon icon="uil:copy" /> */}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td className="center_empty_msg" colSpan="4">
                No agents available
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="pagination">
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index + 1}
            onClick={() => paginate(index + 1)}
            className={currentPage === index + 1 ? "active" : ""}
          >
            {index + 1}
          </button>
        ))}
      </div>

      {loadingForLoader && (
        <div className="loading-container" centered size="lg">
          <div>
            <HashLoader color="#0C72F7" />
          </div>
        </div>
      )}

      {/* Modal 1 */}
      <Modal show={agentModal} onHide={handleAgentModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Create a New Agent</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="create-AI">
            <div className="top">
              <h5>Name</h5>
              <input
                type="text"
                name=""
                id=""
                placeholder="Enter Agent Name here !"
                className="mt-2"
                onChange={handleInputChange}
              />
              {nameError && (
                <p style={{ color: "red", fontSize: 12, marginLeft: 12 }}>
                  {nameError}
                </p>
              )}
            </div>
            <div className="bottom mt-3  ">
              <h5>Choose Your Use Case :</h5>
              <div className="checks mt-2">
                <div
                  className="check-boxes d-none"
                  onClick={(e, value) => {
                    setAgentPromptType(value);
                    // handleCreateAgentModal();
                    // console.log(e);
                    handleSubmit();
                    // handleTextRequest();
                    handlePromptType("Sales");
                    handlesetAgentName("Sales");

                    // handleAgentRequest();
                    // handleInputChange(e);
                  }}
                >
                  <label>
                    <h6>Sales</h6>
                  </label>
                </div>
                <div
                  className="check-boxes"
                  onClick={(e, value) => {
                    // handleCustomerModal();
                    setAgentPromptType(value);
                    handleSubmit();
                    // handleInputChange(e);
                    handlePromptType("customerService");
                    handlesetAgentName("customerService");
                    // handleAgentRequest();
                  }}
                >
                  <label>
                    <h6>Customer Services</h6>
                  </label>
                </div>
                {/* <div
                  className="check-boxes"
                  onClick={(e, value) => {
                    // handleCreateAgentModal();
                    setAgentPromptType(value);
                    handleSubmit();
                    handlePromptType("custom");
                    handlesetAgentName("custom");
                    // handleAgentRequest();
                    // handleInputChange(e);
                  }}
                >
                  <label>
                    <h6>Other (Custom use case)</h6>
                  </label>
                </div> */}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Modal 2 */}
      <Modal
        show={createAgent}
        onHide={handleCreateAgentModal}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Choose your Editing Mode</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-2-body">
          <label htmlFor="select" className="label-1 m-auto">
            <div
              className="left"
              onClick={() => {
                handleScriptModal();
                // handleAgentRequest();
              }}
            >
              <div className="two">
                <h6>Standard (Recommended)</h6>
                {/* <input type="radio" name="select" id=" select" /> */}
              </div>
              <p className="p2 mt-3">
                Standard mode allows you to launch voxr faster and with more
                simplicity. It requires less time and technical skill. It is the
                recommended for the far majority of our users. If you don't know
                what to choose, choose this mode.
              </p>
            </div>
          </label>
          <label htmlFor="select" className="label-2 d-none">
            <div className="right" onClick={handleScriptModal}>
              <div className="two">
                <h6>Advanced</h6>
                {/* <input type="radio" name="select" id="select" /> */}
              </div>
              <p className="p2 mt-3">
                Advanced mode allows you to edit voxr's underlying prompt and
                model. This is for users with more technical context that want
                to test on a deeper level. Only recommended if you have
                experience prompting.
              </p>
            </div>
          </label>
        </Modal.Body>
        {/* <Modal.Footer>
          <div className="AI-agent-button">
            <button>Choose Selected Mode</button>
            <button onClick={() => navigate("/script")}>
              Choose Selected Mode
            </button>
          </div>
        </Modal.Footer> */}
      </Modal>
      {/* Modal 3 */}
      <Modal show={scriptModal} onHide={handleScriptModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            How do you want to create a script for your agent to follow?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-2-body  ">
          {/* <label className="label-1">
            <div
              className="left"
              onClick={() => {
                handleTextRequest(userId);
              }}
            >
              <div className="two">
                <h6>Magically Generate Using AI</h6>
              </div>
              <p className="p2 mt-3">
                Have AI magically create a script for you by uploading a call
                recording, pasting in your script, or let voxr ask you a few
                questions to get context.
              </p>
            </div>
          </label> */}
          <label className="label-2">
            <div
              className="right"
              onClick={() => {
                handleTextRequest(userId);
              }}
            >
              <div className="two">
                <h6>Create From Scratch</h6>
              </div>
              <p className="p2 mt-3">
                Start with a fresh blank state and create a script from scratch.
              </p>
            </div>
          </label>
        </Modal.Body>
        {/* <Modal.Footer>
          <div className="AI-agent-button">
            <button onClick={setGenerateModal}>
              Choose Script Creation Type
            </button>
          </div>
        </Modal.Footer> */}
      </Modal>
      {/* Modal 4  open on the click of customer button */}
      <Modal
        show={customerModal}
        onHide={handleCustomerModal}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Choose your Editing Mode</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-2-body">
          <label htmlFor="select" className="label-1">
            <div className="left" onClick={handleCreateAgentModal}>
              <div className="two">
                <h6>General (Recommended)</h6>
              </div>
              <p className="p2 mt-3">
                Let the customer share why they are calling in and answer their
                questions based off of a general knowledge base. (Ex: A typical
                cs call where a customer calls in for help)
              </p>
            </div>
          </label>
          <label htmlFor="select" className="label-2">
            <div className="right" onClick={handleCreateAgentModal}>
              <div className="two">
                <h6>Objective Based</h6>
              </div>
              <p className="p2 mt-3">
                Have your AI follow your specific script hyper closely to
                accomplish one specific objective. (Ex: Get a referral, survey
                the customer, complete a temp check, etc.)
              </p>
            </div>
          </label>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Agent;
